

























































































































































































































































































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import EventTaskList from '@components/EventTaskList'
import Trigger from '@modules/ui/triggers/Trigger'
import PricingTable from '@ui/Event/PricingTable'
import PolygonsTable from '@ui/Event/PolygonsTable'

settings =
  name: 'EventSuperSection'
  vue:
    props: ['event', 'context', 'actions', 'options']
    components: { Modal, EventTaskList, Trigger, PricingTable, PolygonsTable }

    data: ->
      editModal:
        objectId: null
        label: ''
        fieldName: null
        value: null
        fieldType: ''
        options: null
        show: false
        resourceName: null
        resourceSlug: null
        onChange: null
      serviceType: 'other'

    computed:
      organizerOptions: ->
        { id: organizer.id, name: "#{organizer.first_name} #{organizer.last_name} <#{organizer.email}>" } for organizer in @context.organizers

      productSamplingSpace: -> @event.spaces["Product Sampling"]

      actionsForPricingModel: ->
        {
          hiUpdatePricingModelTrigger: @actions.hiUpdatePricingModelTrigger,
          hiRemoveSpecialPricingTrigger: @actions.hiRemoveSpecialPricingTrigger
        }

      geoJsonIO: -> "http://geojson.io/#map=17/#{@event.lat}/#{@event.lng}"

      standardPrincingAgreementLabel: ->
        return "Yes" if @productSamplingSpace.agree_to_standard_pricing
        return "No" if false is @productSamplingSpace.agree_to_standard_pricing
        return "Not answered"

      is_professional_service: -> @event.is_professional_service
      professional_service_type: -> @event.professional_service_type

      serviceTypesOptions: -> [
        { name: "Other" , type: "other" }
        { name: "Printing" , type: "printing" }
        { name: "Shipping" , type: "shipping" }
        { name: "Staffing" , type: "staffing" }
        { name: "Custom fabrication" , type: "custom_fabrication" }
        { name: "Redemption program receipt scanning" , type: "redemption_scanning" }
      ]

    methods:
      editField: (objectId, label, fieldName, value, fieldType='el-input', options={}) ->
        @editModal.objectId = objectId
        @editModal.label = label
        @editModal.fieldName = fieldName
        @editModal.value = value
        @editModal.fieldType = fieldType
        @editModal.selectOptions = options.selectOptions
        @editModal.onChange = @saveField
        @editModal.resourceName = 'event'
        @editModal.resourceSlug = "events/#{@event.id}"
        @editModal.show = true

      saveField: ->
        payload = {}
        payload.id = @editModal.objectId
        payload[@editModal.fieldName] = @editModal.value
        @save("events/#{@event.id}", 'event', payload)

      onSave: (item) ->
        @actions.fetchAllResources()
        @editModal.show = false

      addPrivateTagToSet: (tag)-> @actions.addPrivateTagToSet tag
      untagSet: (tag)-> @actions.untagSet tag

      untagPayload: (tag) -> { options: { tag } }
      unflagPayload: (flag) -> { options: { flag } }

      autoProjectingPayload: -> { options: { value: !@event.enable_auto_projecting } }

export default VueOptions.vue settings
